import React from 'react';
import cn from 'classnames';
import css from './Card.module.scss';

export default function Card({
  number,
  title,
  className,
  children
}: {
  number: number;
  title: string;
  className?: string;
  children: any;
}) {
  return (
    <section className={cn(css.wrapper, className)}>
      <div className={css.header}>
        <div className={css.headerNumber}>{number}</div>
        <div className={css.title}>{title}</div>
      </div>
      <div className={css.content}>{children}</div>
    </section>
  );
}
